import main from './letter-spacing.svg';
import active from './letter-spacing-filled.svg';
import disabled from './letter-spacing-gestalt.svg';

export default { main, active, disabled };
